import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.132 11.075c-.446.05-.876.2-1.256.437l-15.232 9.52a3.5 3.5 0 0 0 .002 5.938l15.252 9.519a3 3 0 0 0 4.57-2.212c.356-3.195.533-6.589.532-10.183a3.5 3.5 0 0 0 1.646 2.876l15.252 9.519a3 3 0 0 0 4.57-2.212c.357-3.203.534-6.607.532-10.213-.002-3.626-.187-7.073-.553-10.342a3 3 0 0 0-4.571-2.21l-15.232 9.52A3.497 3.497 0 0 0 24 23.923c-.007-3.573-.191-6.974-.553-10.2a3 3 0 0 0-3.315-2.647ZM24 23.923a3.606 3.606 0 0 0 0 .17v-.169ZM4.704 22.729l15.232-9.52a1 1 0 0 1 1.524.736c.357 3.193.537 6.567.54 10.12.002 3.534-.171 6.863-.52 9.99a1 1 0 0 1-1.523.737L4.705 25.273a1.5 1.5 0 0 1 0-2.544Zm22 0a1.5 1.5 0 0 0 .001 2.544l15.252 9.52a1 1 0 0 0 1.523-.738c.349-3.127.522-6.456.52-9.99-.002-3.553-.183-6.927-.54-10.12a1 1 0 0 0-1.524-.737l-15.232 9.52Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "Rewind_svg__a",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 11,
    width: 45,
    height: 26
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.132 11.075c-.446.05-.876.2-1.256.437l-15.232 9.52a3.5 3.5 0 0 0 .002 5.938l15.252 9.519a3 3 0 0 0 4.57-2.212c.356-3.195.533-6.589.532-10.183a3.5 3.5 0 0 0 1.646 2.876l15.252 9.519a3 3 0 0 0 4.57-2.212c.357-3.203.534-6.607.532-10.213-.002-3.626-.187-7.073-.553-10.342a3 3 0 0 0-4.571-2.21l-15.232 9.52A3.497 3.497 0 0 0 24 23.923c-.007-3.573-.191-6.974-.553-10.2a3 3 0 0 0-3.315-2.647ZM24 23.923a3.606 3.606 0 0 0 0 .17v-.169ZM4.704 22.729l15.232-9.52a1 1 0 0 1 1.524.736c.357 3.193.537 6.567.54 10.12.002 3.534-.171 6.863-.52 9.99a1 1 0 0 1-1.523.737L4.705 25.273a1.5 1.5 0 0 1 0-2.544Zm22 0a1.5 1.5 0 0 0 .001 2.544l15.252 9.52a1 1 0 0 0 1.523-.738c.349-3.127.522-6.456.52-9.99-.002-3.553-.183-6.927-.54-10.12a1 1 0 0 0-1.524-.737l-15.232 9.52Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Rewind_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h48v48H0z"
  })));
};

var SvgRewind = styled(SvgComponent).withConfig({
  displayName: "Rewind__SvgRewind",
  componentId: "sc-1nw1upt-0"
})(["", " ", ""], size, color);
export default SvgRewind;